import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-126">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 bg-white border-t border-border px-4 py-2.5 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-50 md:hidden" data-id="element-127">
          <button onClick={() => {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', {
            content_name: 'El Permiso',
            content_type: 'product',
            value: 7.0,
            currency: 'EUR'
          });
        }
        window.open('https://www.tubienestarinterno.com/cart/53225995501905:1', '_blank');
      }} className="w-full bg-navy text-white font-semibold py-2.5 px-5 rounded-lg shadow-sm text-sm" data-id="element-128">
            Descargar ahora (7€)
          </button>
          <p className="text-center mt-1.5 text-[10px] text-gray font-medium" data-id="element-129">
            Pago seguro · Acceso inmediato · Sin suscripción
          </p>
        </motion.div>}
    </AnimatePresence>;
}